import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const PackingsService = {
  save: (
    name: string,
    _id?: string,
    // account?: string,
    contact?: string,
    phone_number?: string,
    email?: string,
    status?: boolean, 
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}packings`, { _id, account, name, contact, phone_number, email, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}packings/${account}`);
  },
}